// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1FNIV","row":"styles_row__EJN5S"};